import React, { useEffect, useState } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Button from "@material-ui/core/Button";
import { base_url } from "../Api/Api";
import Itemeduc from "./Itemeducation";
import { withRouter } from "react-router";
import SkltnCourse from "./SkltnCourses";
import { Signle_Call } from "../Api/Api";
import Cookies from "universal-cookie";

const Mycourses = (props) => {
  const [state, setState] = useState({
    data: [],
    loader: true,
    tutorialCount: 0,
    locked: false,
  });
  const cookies = new Cookies()

  useEffect(() => {
    if (cookies.get("api_key") == null) {
      props.history.push("/entrance");
    }
    window.scrollTo(0, 0);

    base_url
      .get(`course/${props.match.params.id}`)
      .then((response) => {
        const tutorialCount = response.data.tutorials;
        let readedCount = 0;
        tutorialCount.map((info) => (readedCount += info.read ? 1 : 0));
        setState({
          ...state,
          data: response.data,
          loader: false,
          tutorialCount: response.data.tutorials.length,
          locked: readedCount == response.data.tutorials.length,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
        }
      });
  }, []);

  const handleOnclick = (id) => {
    props.history.push(`/Education/course-content/${id}`);
  };

  const startQuiz = async () => {
    const apiCall = () => {

      const apiCall = async (tools) => {
        const ApiCall = await Signle_Call(tools);
        return ApiCall;
      };
      return new Promise((result) => {
        result(
          apiCall({
            method: "get",
            data: false,
            path: `exam/${props.match.params.id}`,

          })
        );
      });
    };
    const getExam_result = await apiCall();
    if (getExam_result.type) {
      getExam_result.response.data.exam_id = props.id;
      props.history.push("/exam", getExam_result.response.data);
    }
  };

  return (
    <div className="inner-course">
      <div className="contain">
        <Button variant="contained" onClick={() => props.history.goBack()}>
          بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i>
        </Button>
        <div className="box-courses">
          <div className="inner-mycours">
            <div className="progresbar">
              <span>{state.data.length !== 0 ? state.data.progress : 0}%</span>
              <LinearProgress
                variant="determinate"
                value={state.data.length !== 0 ? state.data.progress : ""}
              />
            </div>
            <div className="title-quiz">
              <h4>کرس درسی</h4>
              {/* <Button
                                variant="contained"
                                className={`${state.locked ? '' : 'disable'}`}
                                onClick={startQuiz}>
                                شروع آزمون
                            </Button> */}
            </div>
            <div className="list-item">
              {state.data.length == 0 ? (
                state.tutorialCount.length == 0 ? (
                  <span className="no-content">اطلاعاتی وجود ندارد</span>
                ) : (
                  <SkltnCourse />
                )
              ) : (
                state.data.tutorials.map((info) => (
                  <Itemeduc
                    title={info.title}
                    image={info.image}
                    read={info.read}
                    handleClick={() => handleOnclick(info.id)}
                  />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Mycourses);
